<script setup lang="ts">
import { watchEffect } from 'vue';
import { SCREENS, useNav } from '../navigation';

/** Desenha a tela de baixo e, se houver, os modais abertos por cima dela. Também acompanha o título da aba. */
const nav = useNav();
watchEffect(() => {
  const title = SCREENS[nav.current.value.name]?.title;
  document.title = title ? `${title} · O jogo` : 'O jogo';
});
</script>

<template>
  <component :is="SCREENS[entry.name]!.component" v-for="entry in nav.visible.value" :key="entry.id" />
</template>
